import { Component, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UserService } from '../../../services/user.service';
import { ProjectsService } from '../../../services/projects.service';

@Component({
  selector: 'app-edit-user',
  templateUrl: './edit-user.component.html',
  styleUrl: './edit-user.component.scss'
})
export class EditUserComponent {
  projects: any = [];
  user: {
    id: string,
    firstName: string,
    lastName: string,
    email: string,
    isActive: boolean,
    isDexioAdmin: boolean,
    externalId: string | null,
    verifyExternalId: boolean
  } = { id: '', firstName: '', lastName: '', email: '', isActive: false, isDexioAdmin: false, externalId: null, verifyExternalId: true };

  constructor(
    @Optional() private readonly dialogRef: MatDialogRef<EditUserComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly projectsService: ProjectsService,
    private readonly adminUserService: UserService
  ){
    if (data) { this.user = data; this.user.verifyExternalId = data.settings.verifyExternalId; }
  }

  save() {
    var data = {
      id: this.user.id,
      firstName: this.user.firstName,
      lastName: this.user.lastName,
      email: this.user.email,
      isActive: this.user.isActive,
      isAdmin: this.user.isDexioAdmin,
      externalId: this.user.externalId,
      verifyExternalId: this.user.verifyExternalId
    };
    this.adminUserService.editUser(data).subscribe(_ => {
      if (this.dialogRef) { this.dialogRef.close('save'); }
    });
  }
  close() {
    if (this.dialogRef) { this.dialogRef.close('cancel'); }
  }
}
